<template>
  <div id="nav">
    <div class="nav_logo">
      <a href="javascript:void(0)" @click="goHome()" v-if="!isCould">
        <img
          alt="投票、企业投票云服务、企业投票、网络投票、微信投票、会议投票"
          src="../assets/images/logo.png"
        />
      </a>
    </div>
    <div class="mask" v-if="isQuickShow" @click="isQuickShow = false"></div>
    <div class="quick hidden-sm-and-down" v-if="!isCould">
      <div
        @click="quickClick"
        :class="
          this.isQuickShow
            ? 'quick_event_list_bar_show'
            : 'quick_event_list_bar'
        "
      >
        <span class="span_tip quick_event_list_bar_tip">
          {{ quickNumber }}
        </span>
        <span>快速访问</span>
        <span>
          <i
            class="el-icon-arrow-down"
            :style="
              this.isQuickShow
                ? 'transform: rotate(-180deg);transition: all .5s'
                : 'transform: rotate(0deg);transition: all .5s'
            "
          >
          </i>
        </span>
      </div>
      <!-- <el-collapse-transition> -->
      <div class="quick_event_list" v-show="this.isQuickShow">
        <el-table
          v-loading="quickLoading"
          :data="quickTableData"
          style="width: 100%"
          :show-header="false"
          @row-click="quickItemClick"
        >
          <el-table-column
            ><template slot-scope="scope">
              <div>
                <span
                  class="iconfont icon-huiyi3-copy"
                  v-if="scope.row.MeetingType === 0"
                  style="color: #0093cb; display: inline-block"
                ></span>
                <span
                  class="iconfont icon-qa1"
                  v-if="scope.row.MeetingType === 1"
                  style="color: #e74c3f; display: inline-block"
                ></span>
                <span
                  class="iconfont icon-toupiaoguanli"
                  v-if="scope.row.MeetingType === 2"
                  style="color: #e74c3f; display: inline-block"
                ></span>
                <span
                  class="quick_event_list_item"
                  :title="scope.row.MeetingName"
                  v-html="scope.row.MeetingName"
                >
                </span>
              </div>
              <div>
                {{ scope.row.StartTime | dateformat('YYYY.MM.DD HH:mm') }}
                -
                {{ scope.row.EndTime | dateformat('YYYY.MM.DD HH:mm') }}
              </div>
            </template>
          </el-table-column>
          <el-table-column width="80"
            ><template slot-scope="scope"
              ><div class="quick_event_list_state">
                <span
                  v-if="scope.row.State === 1"
                  class="span_tip draft_bg_color"
                >
                  {{ scope.row.StrState }}
                </span>
                <span
                  v-if="scope.row.State === 4"
                  class="span_tip publish_bg_color"
                >
                  {{ scope.row.StrState }}
                </span>
                <span
                  v-if="scope.row.State === 3"
                  class="span_tip end_bg_color"
                >
                  {{ scope.row.StrState }}
                </span>
                <span
                  v-if="scope.row.State === 6"
                  class="span_tip close_bg_color"
                >
                  {{ scope.row.StrState }}
                </span>
              </div></template
            ></el-table-column
          >
        </el-table>
        <div class="quick_event_list_btns">
          <el-button @click="seeAllMeeting()">查看全部</el-button>
          <el-button
            type="primary"
            @click="createMeeting()"
            v-if="userRole === 2 || userRole === 3"
          >
            创建
          </el-button>
        </div>
      </div>
      <!-- </el-collapse-transition> -->
    </div>
    <div class="nav_right" v-if="!isCould">
      <a
        title="用户手册"
        href="#/manua"
        target="_blank"
        style="color: #409eff; margin-right: 20px"
        class="hidden-sm-and-down"
      >
        <i
          class="iconfont icon-bangzhu"
          style="vertical-align: initial; margin-right: 0px"
        ></i>
        用户手册
      </a>
      <el-link
        icon="iconfont icon-xiaoxizhongxin"
        :underline="false"
        v-if="false"
      ></el-link>
      <el-popover placement="bottom-end" trigger="click" v-model="isShowNav">
        <div class="nav_avatar_menu" @click="leftNavSelect('meetingList')">
          <a>
            <i class="iconfont icon-huiyizhongxin-toupiao"></i>
            会议/活动
          </a>
        </div>
        <div class="nav_avatar_menu" @click="leftNavSelect('personal')">
          <a>
            <i class="iconfont icon-jibenxinxi"></i>
            用户中心
          </a>
        </div>
        <div
          class="nav_avatar_menu"
          @click="leftNavSelect('financial')"
          v-if="false"
        >
          <a>
            <i class="iconfont icon-chongzhizhongxin"></i>
            充值中心
          </a>
        </div>
        <div
          class="nav_avatar_menu"
          @click="leftNavSelect('user')"
          v-if="false"
        >
          <a>
            <i class="iconfont icon-yonghuguanli"></i>
            用户管理
          </a>
        </div>
        <div
          class="nav_avatar_menu"
          @click="leftNavSelect('company')"
          v-if="isSystemAdmin"
        >
          <a>
            <i class="iconfont icon-familyGroup"></i>
            企业管理
          </a>
        </div>
        <div
          class="nav_avatar_menu"
          @click="leftNavSelect('userPostQuery')"
          v-if="isSystemAdmin"
        >
          <a>
            <i class="iconfont icon-familyGroup"></i>
            人员职位查询
          </a>
        </div>
        <div class="nav_avatar_menu" @click="openUpdatePwd()">
          <a>
            <i class="el-icon-lock"></i>
            修改密码
          </a>
        </div>
        <div class="nav_avatar_menu" @click="userOut()">
          <a>
            <i class="el-icon-switch-button"></i>
            退出
          </a>
        </div>
        <div class="nav_avatar_box" slot="reference">
          <el-avatar size="medium" :src="userInfo.avatarPic">
            <i class="el-icon-user-solid" style="font-size: 16px"></i>
          </el-avatar>
          <span class="nav_avatar_name hidden-xs-only">
            {{ userInfo.displayName }}
          </span>
        </div>
      </el-popover>
    </div>
    <div class="nav_right" v-if="isCould">
      <a
        title="用户手册"
        href="#/manua"
        target="_blank"
        style="color: #409eff; margin-right: 20px"
        class="hidden-sm-and-down"
      >
        <i
          class="iconfont icon-bangzhu"
          style="vertical-align: initial; margin-right: 0px"
        ></i>
        用户手册
      </a>
      <el-link
        icon="iconfont icon-xiaoxizhongxin"
        :underline="false"
        v-if="false"
      ></el-link>
      <el-popover placement="bottom-end" trigger="click" v-model="isShowNav">
        <div class="nav_avatar_menu" @click="leftNavSelect('meetingList')">
          <a>
            <i class="iconfont icon-huiyizhongxin-toupiao"></i>
            会议/活动
          </a>
        </div>
        <div class="nav_avatar_menu" @click="leftNavSelect('personal')">
          <a>
            <i class="iconfont icon-jibenxinxi"></i>
            用户中心
          </a>
        </div>
        <div
          class="nav_avatar_menu"
          @click="leftNavSelect('financial')"
          v-if="false"
        >
          <a>
            <i class="iconfont icon-chongzhizhongxin"></i>
            充值中心
          </a>
        </div>
        <div
          class="nav_avatar_menu"
          @click="leftNavSelect('user')"
          v-if="false"
        >
          <a>
            <i class="iconfont icon-yonghuguanli"></i>
            用户管理
          </a>
        </div>
        <div
          class="nav_avatar_menu"
          @click="leftNavSelect('company')"
          v-if="isSystemAdmin"
        >
          <a>
            <i class="iconfont icon-familyGroup"></i>
            企业管理
          </a>
        </div>
        <div
          class="nav_avatar_menu"
          @click="leftNavSelect('userPostQuery')"
          v-if="isSystemAdmin"
        >
          <a>
            <i class="iconfont icon-familyGroup"></i>
            人员职位查询
          </a>
        </div>
        <div class="nav_avatar_box" slot="reference">
          <span class="nav_avatar_name hidden-xs-only">
            {{ userInfo.displayName }}
          </span>
        </div>
      </el-popover>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Home',
  data () {
    return {
      quickLoading: true,
      quickNumber: 0,
      quickQuery: {
        keyWord: '',
        meetingState: null,
        maxResultCount: 3,
        skipCount: 0
      },
      quickTableData: [],
      isQuickShow: false,
      avatarUrl: require('../assets/images/judgePhoto.png'),
      userInfo: {
        displayName: '',
        avatarPic: ''
      },
      isShowNav: false,
      userRole: -1,
      isSystemAdmin: false,
      isCould: false
    }
  },
  props: {
    fatherNavSelect: {
      type: Function,
      default: null
    }
  },
  methods: {
    quickClick: function () {
      this.isQuickShow = !this.isQuickShow
    },
    getCurrentUserInfo () {
      this.$api.userInfo.getCurrentUserInfo()
        .then(data => {
          this.userInfo.displayName = data.DisplayName
          this.userInfo.avatarPic = data.AvatarPic
          //   if (!this.userInfo.avatarPic) {
          //     this.userInfo.avatarPic = this.avatarUrl
          //   }
        }).catch(err => {
          return err
        })
    },
    getCurrentUserRole: function () {
      this.$api.userInfo.getCurrentUserRole().then(data => {
        this.userRole = data
      }).catch(err => {
        return err
      })
    },
    getMeetingList: function () {
      this.$api.meetingManage.getMeetingList({
        keyWord: this.quickQuery.keyWord,
        meetingState: this.quickQuery.meetingState,
        skipCount: this.quickQuery.skipCount,
        maxResultCount: this.quickQuery.maxResultCount
      })
        .then(data => {
          this.quickTableData = data.Items
          this.quickNumber = data.TotalCount
          this.quickLoading = false
        }).catch(err => {
          return err
        })
    },
    seeAllMeeting: function () {
      this.isQuickShow = false
      this.$router.push({ name: 'meetingList' })
    },
    quickItemClick: function (row, column, event) {
      this.isQuickShow = false
      this.$router.push({ name: 'meetingBasic', params: { mid: row.MeetingID } })
    },
    createMeeting: function () {
      this.isQuickShow = false
      this.$router.push({
        name: 'meetingList',
        params: { isCreate: true }
      })
    },
    goHome: function () {
      //   this.$router.push({ path: '/home.html' })
      window.location.href = '/index.html'
    },
    // 退出登录
    userOut: function () {
      this.$confirm('确认退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        this.$store.commit('REMOVE_ACCOUNT')
        // this.$router.go(0)
        this.$router.push({ name: 'login', params: { loginType: 'signIn' } })
      }).catch(() => {

      })
    },
    openUpdatePwd: function () {
      this.$root.$emit('openUpdatePwd')
    },
    leftNavSelect: function (pathName) {
      this.fatherNavSelect(pathName, '')
      this.isShowNav = false
    },
    getIsCompanySystem () {
      this.$api.role.getIsCompanySystem().then(data => {
        this.isSystemAdmin = data.IsSystemAdmin
      }).catch(err => {
        return err
      })
    }
  },
  created () {
    if (this.$route.query.site) {
      if (this.$route.query.site === 'cloud') {
        this.isCould = true
      }
    }
    if (this.$store.state.isLogin) {
      this.getCurrentUserInfo()
      this.getMeetingList()
      this.getCurrentUserRole()
      this.getIsCompanySystem()
    }
  }
}
</script>
<style lang="less">
.el-popover {
  padding: 0px;
}
</style>
